<!-- 视频页面 -->
<template>
  <div>
    <Top></Top>
    <Rotation :type="lbt"></Rotation>

    <div id="middleCon">
      <!-- 精品影像素材 -->

      <div class="goodeVideo">
        <h2>精品影像素材</h2>
        <p class="top-p">Premium video materials</p>
      </div>

      <div class="videoBox1">
        <div class=" active" id="home">
          <!-- 轮播图 -->
          <!-- <div class="rotation2"> -->
          <el-carousel trigger="click" class="demonstration2">
            <el-carousel-item v-for="item in jpVideo.slice(0, 3)" :key="item.videoId">
              <div id="posTop">
                <div class="address">
                  {{ item.address }}
                </div>
              </div>
              <div id="posBottom">
                <img :src="item.headImage" alt="">
                <div class="name">{{ item.username }}</div>
              </div>
              <div class="shichang" v-html="formatSeconds(item.duration)"></div>
              <img @click="pushVideoDetial(item.videoId)" :src="item.coverUrl + '?x-oss-process=image/resize,h_800'" />

            </el-carousel-item>
          </el-carousel>

          <div class="imgBox" v-for="item in jpVideo.slice(3, 16)" :key="item.videoId">
            <div class="shichang" v-html="formatSeconds(item.duration)"></div>
            <div id="posTop">
              <div class="address">
                {{ item.address }}
              </div>
            </div>
            <div id="posBottom">
              <img :src="item.headImage" alt="">
              <div class="name">{{ item.username }}</div>
            </div>
            <img @click="pushVideoDetial(item.videoId)" v-lazy="item.coverUrl + '?x-oss-process=image/resize,h_300'"
              alt="" />
          </div>
        </div>
      </div>


      <!-- 新片速递 -->
      <div class="goodeVideo">
        <h2 style="">新片速递</h2>
        <p class="top-p">New video updates</p>
        <!-- <span class="find-more">查看更多</span> -->
      </div>

      <div class="videoBox2">

        <div class="imgBox" v-for="(item, index) in newVideo.slice(0, 12)" :key="index">
          <div class="shichang" v-html="formatSeconds(item.duration)"></div>
          <div id="posTop">
            <div class="address">
              {{ item.address }}
            </div>
          </div>
          <div id="posBottom">
            <img :src="item.headImage" alt="">
            <div class="name">{{ item.username }}</div>
          </div>
          <img @click="pushVideoDetial(item.videoId)" v-lazy="item.coverUrl + '?x-oss-process=image/resize,h_300'"
            alt="" />
        </div>

      </div>
      <!-- 
      <el-container>
        <div class="" style="
    position: relative;
        width:100%;
        height: 30px;
        margin: 52px auto ;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center ">
          <h2 style="font-size: 24px; font-weight: 700">视频成片</h2>
          <p class="top-p">FAMOUS PHOTOGRAPHER AND EXCELLEND PHOTOGRAPHER</p>

        </div>

                                                        </el-container> -->



    </div>
    <!-- 回到顶部 -->
    <el-backtop :visibility-height="300">
      <div class="inn">
        <img src="@/imgs/backtop.png" alt="">
      </div>
    </el-backtop>
    <service />
    <shopFloat />
    <Foot></Foot>

  </div>
</template>
<script>
import { setLocalStorage } from "../utils/auth";
import { getLocalStorage } from "../utils/auth";
import { setToken } from "../utils/auth";
import Top from "../components/top";
import Rotation from "../components/rotation.vue";
import Foot from "../components/foot.vue";
var justifiedLayout = require("justified-layout");
export default {
  components: { Top, Rotation, Foot },
  name: "videosource",
  data() {
    return {
      lbt: 'video',//传给子组件用来区别轮播图
      urlList: [
        "http://localhost:3000/attchments/work/2020619/1592560044555-自在如风的少年.jpg",
        "http://localhost:3000/attchments/work/2020619/1592560325880-磊-重庆场.jpg",
      ],
      fullWidth: document.documentElement.clientWidth,
      geometryList: "",
      imgList: [],
      dataAr: [],
      dataArr: [],
      user_url: "",
      page: 1,
      isactive: true,
      actindex: 1,
      tags: [],
      jpVideo: [], //精品视频
      newVideo: [], //新片视频
    };
  },
  created() {
    this.getjpVideo()
  },
  methods: {
    async getjpVideo() {
      const res = await this.$axios.get('/homeReception/findVideoBoutique', { params: { commendType: 3 } })
      // console.log(res);
      this.jpVideo = res.data
      console.log(this.jpVideo);
      this.getNewVideo()
    },

    // 新片速递
    async getNewVideo() {
      const res = await this.$axios.get('/homeReception/newVideoList', { params: { commendType: 3 } })
      // console.log(res);
      this.newVideo = res.data
      // console.log(this.newVideo);
    },


    // 点击视频跳转详情页
    pushVideoDetial(id) {
      console.log(212);
      let routerUrl = this.$router.resolve({
        path: '/videoDetail',
        query: { id: id }
      })
      // console.log(routerUrl);
      window.open(routerUrl.href, "_brank")
    },


    // 时长转换
    formatSeconds(value) {
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (secondTime >= 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime >= 60) {
          hourTime = parseInt(minuteTime / 60);
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      var result = "" + (parseInt(secondTime) < 10 ? "0" + parseInt(secondTime) : parseInt(secondTime));

      // if (minuteTime > 0) {

      // }
      if (hourTime > 0) {
        result = "" + (parseInt(hourTime) < 10 ? "0" + parseInt(hourTime) : parseInt(hourTime)) + ":" + result;

      } else {
        result = "" + (parseInt(minuteTime) < 10 ? "0" + parseInt(minuteTime) : parseInt(minuteTime)) + ":" + result;
      }
      return result;
    },


    //秒转换为mm:ss
    dateFormat(time) {
      let minutes = parseInt(time % (1000 * 60 * 60) / (60));
      let seconds = parseInt(time % (1000 * 60))


      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      return minutes + ":" + seconds;
    }

  },
};
</script>
<style lang="scss" scoped>
// 移动端
// @media screen and (min-width: 375px) and (max-width: 1456px) {
//   #middleCon {
//     width: 100% !important;
//     padding: 10px !important;

//     .goodeVideo {
//       width: 100% !important;
//     }

//     .videoBox1 {
//       width: 100% !important;

//       .demonstration2 {
//         width: 932px !important;
//         height: 560px !important;

//       }

//       .imgBox {
//         width: 460px !important;
//         height: 275px !important;
//       }
//     }

//     .videoBox2 {
//       width: 100% !important;

//       .imgBox {
//         width: 460px !important;
//         height: 275px !important;
//       }
//     }
//   }
// }

@-webkit-keyframes loading {
  0% {
    background-position: 100% 50%
  }

  to {
    background-position: 0 50%
  }
}

@keyframes loading {
  0% {
    background-position: 100% 50%
  }

  to {
    background-position: 0 50%
  }
}


#middleCon {
  width: 1600px;
  margin: 0 auto;
}

// 精品影像素材
.goodeVideo {
  width: 100%;
  height: 30px;
  margin: 72px auto;
  display: flex;
  justify-content: center;
  flex-direction: column;

  align-items: center;

  h2 {
    font-size: 24px;
    font-weight: bold;
  }
}

// 盒子1
.videoBox1 {
  margin-top: 30px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  justify-content: space-between;

  .imgBox {
    float: left;
    position: relative;
    width: 305px;
    height: 179px;
    margin-bottom: 15px;
    margin-right: 15px;
    overflow: hidden;
    position: relative;
    /* 以下代码实现背景动画效果 */
    animation: loading 1.4s ease infinite;
    -webkit-animation: loading 1.4s ease infinite;
    background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #ccc), color-stop(37%, #e3e3e3), color-stop(63%, #ccc));
    background-image: -o-linear-gradient(left, #ccc 25%, #e3e3e3 37%, #ccc 63%);
    background-image: linear-gradient(90deg, #ccc 25%, #e3e3e3 37%, #ccc 63%);
    background-size: 400% 100%;

    // 图片遮罩
    &:nth-child(4),
    &:nth-child(7),
    &:nth-child(12) {
      margin-right: 0 !important;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      /* 以下代码实现背景动画效果 */
      animation: loading 1.4s ease infinite;
      -webkit-animation: loading 1.4s ease infinite;
      background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #ccc), color-stop(37%, #e3e3e3), color-stop(63%, #ccc));
      background-image: -o-linear-gradient(left, #ccc 25%, #e3e3e3 37%, #ccc 63%);
      background-image: linear-gradient(90deg, #ccc 25%, #e3e3e3 37%, #ccc 63%);
      background-size: 400% 100%;
    }

    &:hover #posBottom {
      bottom: 0,
    }

    &:hover #posTop {
      top: 0,

    }

    #posTop {
      width: 100%;
      height: 40px;
      background: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
      position: absolute;
      left: 0;
      top: -50px;
      transition: all 0.2s;
      display: flex;
      align-items: center;
      padding: 0 10px;

      .address {
        color: #fff;
        font-size: 13px;
      }
    }

    #posBottom {
      display: flex;
      align-items: center;
      width: 100%;
      height: 50px;
      background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
      position: absolute;
      left: 0;
      bottom: -50px;
      transition: all 0.2s;
      padding: 0 10px;



      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }

      .name {
        margin-left: 8px;
        color: #fff;
        font-size: 13px;
      }
    }



    .shichang {
      font-size: 12px;
      position: absolute;
      bottom: 8px;
      right: 8px;
      border-radius: 10px;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.5);
      padding: 2px 8px;
      z-index: 9;
    }
  }
}

.newVideo {
  position: relative;
  width: 100%;
  height: 30px;
  margin: 52px auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;


}

// 盒子2
.videoBox2 {
  margin-top: 30px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  // justify-content: space-between;

  .imgBox {
    position: relative;
    width: 308px;
    height: 174px;
    margin-bottom: 14px;
    margin-right: 14px;
    overflow: hidden;
    position: relative;
    /* 以下代码实现背景动画效果 */
    animation: loading 1.4s ease infinite;
    -webkit-animation: loading 1.4s ease infinite;
    background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #ccc), color-stop(37%, #e3e3e3), color-stop(63%, #ccc));
    background-image: -o-linear-gradient(left, #ccc 25%, #e3e3e3 37%, #ccc 63%);
    background-image: linear-gradient(90deg, #ccc 25%, #e3e3e3 37%, #ccc 63%);
    background-size: 400% 100%;

    &:nth-child(5n) {
      margin-right: 0 !important;
    }


    // 图片遮罩

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      /* 以下代码实现背景动画效果 */
      animation: loading 1.4s ease infinite;
      -webkit-animation: loading 1.4s ease infinite;
      background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #ccc), color-stop(37%, #e3e3e3), color-stop(63%, #ccc));
      background-image: -o-linear-gradient(left, #ccc 25%, #e3e3e3 37%, #ccc 63%);
      background-image: linear-gradient(90deg, #ccc 25%, #e3e3e3 37%, #ccc 63%);
      background-size: 400% 100%;
    }

    &:hover #posBottom {
      bottom: 0,
    }

    &:hover #posTop {
      top: 0,

    }

    #posTop {
      width: 100%;
      height: 40px;
      background: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
      position: absolute;
      left: 0;
      top: -50px;
      transition: all 0.2s;
      display: flex;
      align-items: center;
      padding: 0 10px;

      .address {
        color: #fff;
        font-size: 13px;

      }
    }

    #posBottom {
      display: flex;
      align-items: center;
      width: 100%;
      height: 50px;
      background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
      position: absolute;
      left: 0;
      bottom: -50px;
      transition: all 0.2s;
      padding: 0 10px;

      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }

      .name {
        margin-left: 8px;
        color: #fff;
        font-size: 13px;

      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .shichang {
      font-size: 12px;
      position: absolute;
      bottom: 8px;
      right: 8px;
      border-radius: 10px;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.5);
      padding: 2px 8px;
    }
  }

}



.demonstration2 {
  float: left;
  margin-right: 15px;
  width: 627px;
  height: 374px;

  /deep/ .el-carousel__container {
    height: 100% !important;
    height: 100%;
    position: relative;
    overflow: hidden;

    /* 以下代码实现背景动画效果 */
    animation: loading 1.4s ease infinite;
    -webkit-animation: loading 1.4s ease infinite;
    background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #ccc), color-stop(37%, #e3e3e3), color-stop(63%, #ccc));
    background-image: -o-linear-gradient(left, #ccc 25%, #e3e3e3 37%, #ccc 63%);
    background-image: linear-gradient(90deg, #ccc 25%, #e3e3e3 37%, #ccc 63%);
    background-size: 400% 100%;

    // 图片遮罩
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      /* 以下代码实现背景动画效果 */
      animation: loading 1.4s ease infinite;
      -webkit-animation: loading 1.4s ease infinite;
      background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #ccc), color-stop(37%, #e3e3e3), color-stop(63%, #ccc));
      background-image: -o-linear-gradient(left, #ccc 25%, #e3e3e3 37%, #ccc 63%);
      background-image: linear-gradient(90deg, #ccc 25%, #e3e3e3 37%, #ccc 63%);
      background-size: 400% 100%;
    }

    &:hover #posBottom {
      bottom: 0,
    }

    &:hover #posTop {
      top: 0,

    }

    #posTop {
      width: 100%;
      height: 40px;
      background: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
      position: absolute;
      left: 0;
      top: -50px;
      transition: all 0.2s;
      display: flex;
      align-items: center;
      padding: 0 10px;

      .address {
        color: #fff;
        font-size: 13px;
      }
    }

    #posBottom {
      display: flex;
      align-items: center;
      width: 100%;
      height: 50px;
      background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
      position: absolute;
      left: 0;
      bottom: -50px;
      transition: all 0.2s;
      padding: 0 10px;

      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }

      .name {
        margin-left: 8px;
        color: #fff;
        font-size: 13px;
      }

      .shichang {
        font-size: 12px;
        position: absolute;
        bottom: 8px;
        right: 8px;
        border-radius: 10px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
        padding: 2px 8px;
        z-index: 999;
      }
    }

    .shichang {
      font-size: 12px;
      position: absolute;
      bottom: 10px;
      right: 10px;
      border-radius: 10px;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.5);
      padding: 2px 8px;
      z-index: 999;
    }

    img {
      height: 100%;
    }
  }
}




.box {
  position: absolute;
  background: #ededed;
}

.bttn {
  width: 220px;
  height: 70px;
  border-radius: 30px;
  color: #7c7c7c;
  margin: 18px 40px 8px 25px;
}

.top-p {
  font-size: 16px;
  font-weight: normal;
  color: #a3973c;
}

.find-more {
  position: absolute;
  right: 0;
  top: 10px;
}


/deep/ .el-carousel__button {
  display: block;
  width: 8px;
  height: 8px;
  background: #f5f5f5;
  border-radius: 50%;
  opacity: 0.7;
  border: 0 !important;
  border-radius: 50%;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: 0.3s;
}

/deep/ .el-carousel__indicator.is-active button {
  width: 22px;
  height: 7px;
  background: #FFFFFF;
  opacity: 1;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/videosource.vue